<template>
    <section id="job-form" class="job-form">
        <div class="container">
            <div class="card-section">
                <div class="row card-row" v-if="status == true">
                    <div class="col-lg-3 col-md-6" v-for="(item, index) in data" :key="index">
                        <div class="card">
                            <h5 class="card-position">{{ item.position }}</h5>
                            <p class="card-shift">{{ item.time_type }}</p>
                            <!-- <p class="card-disc">
                                {{ item.description }}
                            </p>-->
                            <p class="card-disc">Expiry date: {{ item.expiration_date }}</p>
                            <div class="row">
                                <button
                                    class="apply-button"
                                    @click="setPosition(item)"
                                    v-scroll-to="'#form-job'"
                                >{{ $t('job_form.apply') }}</button>
                                <button
                                    class="details-button"
                                    v-b-modal="item.position"
                                >{{ $t('job_form.details') }}</button>
                                <modal-details-position :my_modal="item.position" :my_id="item.id" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-3 col-md-6">
                        <div class="card">
                            <h5 class="card-position">Backend Developer</h5>
                            <p class="card-shift">
                                Part Time
                            </p>
                            <p class="card-disc">
                                Career Level senior professional
                                <br>
                                Experience 3+ years
                            </p>
                            <div class="row">
                                <button class="apply-button" @click="setPosition('Backend Developer')"
                                    v-scroll-to="'#form-job'">{{ $t('job_form.apply') }}</button>
                                <button class="details-button" v-b-modal.Backend>{{ $t('job_form.details') }}</button>
                                <modal-details-position my_id="Backend" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="card">
                            <h5 class="card-position">Flutter Developer</h5>
                            <p class="card-shift">
                                Full Time
                            </p>
                            <p class="card-disc">
                                Career Level senior professional
                                <br>
                                Experience 3+ years
                            </p>
                            <div class="row"  >
                                <button class="apply-button" @click="setPosition('Flutter Developer')"
                                    v-scroll-to="'#form-job'">{{ $t('job_form.apply') }}</button>
                                <button class="details-button" v-b-modal.Flutter>{{ $t('job_form.details') }}</button>
                                <modal-details-position my_id="Flutter" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="card">
                            <h5 class="card-position">Graphic Designer</h5>
                            <p class="card-shift">
                                Full Time
                            </p>
                            <p class="card-disc">
                                Career Level senior professional
                                <br>
                                Experience 3+ years
                            </p>
                            <div class="row"  >
                                <button class="apply-button" @click="setPosition('Graphic Designer')"
                                    v-scroll-to="'#form-job'">{{ $t('job_form.apply') }}</button>
                                <button class="details-button" v-b-modal.Graphic>{{ $t('job_form.details') }}</button>
                                <modal-details-position my_id='Graphic' />
                            </div>
                        </div>
                    </div>-->
                </div>
                <div v-else>
                    <img src="../assets/img/404.webp" alt="404 page" style="width: 30%" />
                    <p style=" color: var(--main-blue);font-size: 25px;">{{$t('form.no_career')}}</p>
                </div>
            </div>
            <div id="form-job" class="line" v-if="position != null"></div>
            <b-form v-if="position != null" v-scrollanimation>
                <div class="container-form">
                    <h3 class="tap-name">{{ position }}</h3>
                    <div class="row my-row">
                        <div class="col-lg-6">
                            <b-form-group id="name" :label="$t('form.name')">
                                <b-form-input
                                    id="name"
                                    v-model="name"
                                    :placeholder="$t('form.name')"
                                ></b-form-input>
                                <div class="error-section" v-if="v$.name.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.name.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6">
                            <b-form-group id="email" :label="$t('form.email')" >
                                <b-form-input
                                    id="email"
                                    v-model="email"
                                    :placeholder="$t('form.email')"
                                ></b-form-input>
                                <div class="error-section" v-if="v$.email.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.email.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row my-row">
                        <div class="col-lg-6">
                            <b-form-group
                                id="phone_number"
                                :label="$t('form.phone')"
                                
                            >
                                <b-form-input
                                    id="phone_number"
                                    v-model="phone_number"
                                    :placeholder="$t('form.phone')"
                                ></b-form-input>
                                <div class="error-section" v-if="v$.phone_number.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.phone_number.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6">
                            <b-form-group id="cv" label="CV" >
                                <b-form-file accept=".pdf" @change="onCvSelected" v-model="cv"></b-form-file>
                                <div class="error-section" v-if="v$.cv.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.cv.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <vue-recaptcha
                                ref="recaptcha"
                                sitekey="6LeRM6ooAAAAAMlUH4RzG-jJlLooglnsK5aOgor-"
                                style="margin-top: 10px;"
                                @verify="verify"
                                @expired="expired"
                                :load-recaptcha-script="true"
                            />
                        </div>
                    </div>
                    <div style="text-align:justify">
                        <button
                            v-on:click="submitForm"
                            type="button"
                            class="my-button"
                            :disabled="submit && !response"
                        >
                            {{ $t('form.submit') }}
                            <b-spinner
                                v-if="submit && !response"
                                label="Text Centered"
                                style="margin: 0px 5px"
                            ></b-spinner>
                        </button>
                    </div>
                </div>
                <b-modal v-model="modalShow" ok-only style="margin-top: 100px">
                    <p
                        style="text-align: center;margin-top: 15px;font-size: 18px;"
                    >{{ $t('success_message') }}</p>
                </b-modal>
            </b-form>
        </div>
    </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers, minLength, email, maxLength } from '@vuelidate/validators'
import ModalDetailsPosition from './ModalDetailsPosition.vue';
import VueRecaptcha from "vue-recaptcha"

export default {
    name: "job_form",
    props: ['data', 'status'],
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        ModalDetailsPosition,
        VueRecaptcha
    },
    data() {
        return {
            name: '',
            email: '',
            phone_number: '',
            cv: null,
            position: null,
            job_id: null,
            modalShow: false,
            response: false,
            submit: false,
            my_verify: false,
        };
    },
    validations() {
        return {
            name: {
                required: helpers.withMessage('This field is required', required)
            },
            email: {
                required: helpers.withMessage('This field is required', required),
                email: helpers.withMessage('Please enter valid email', email)
            },
            phone_number: {
                required: helpers.withMessage('This field is required', required),
                minLength: helpers.withMessage('Please enter valid phone number', minLength(10)),
                maxLength: helpers.withMessage('Please enter valid phone number', maxLength(10))
            },
            cv: {
                required: helpers.withMessage('This field is required', required),
                fileType: helpers.withMessage('Invalid file type', value => {
                    if (!value) return true;
                    const allowedExtensions = ['pdf'];
                    const extension = value.name.split('.').pop().toLowerCase();
                    return allowedExtensions.includes(extension);
                }),
            },
        }
    },
    methods: {
        verify() {
            this.my_verify = true
        },
        expired() {
            this.my_verify = false
            this.$refs.recaptcha.reset();
        },
        submitForm() {
            console.log(this.my_verify)
            this.v$.$validate()
            if (!this.v$.$error && this.my_verify) {
                this.submit = true
                this.sendData()
            }
        },
        onCvSelected(files) {
            this.cv = files.target.files[0];
        },
        setPosition(item) {
            this.position = item.position;
            this.job_id = item.id
            console.log(this.job_id)
        },
        sendData() {
            const formData = new FormData()
            formData.append('email', this.email)
            formData.append('name', this.name)
            formData.append('cv', this.cv)
            formData.append('phone', this.phone_number)
            formData.append('job_id', this.job_id)
            console.log(formData)
            for (var pair of formData.entries()) {
                console.log(pair)
            }
            this.axios.post(this.$store.state.url + "job-requests", formData)
                .then((res) => {
                    console.log(res)
                    this.response = true
                    if (res.status == 200) {
                        this.modalShow = true
                        this.email = ''
                        this.phone_number = ''
                        this.name = ''
                        this.cv = null
                        this.v$.$reset()
                    }
                })
                .catch(error => {
                    this.response = false
                    this.submit = false
                })
        },

    },
    mounted() {
        document.documentElement.scrollTop = 0;

        // console.log(this.today_date)
    }
};
</script>

<style lang="scss">
.btn-primary {
    color: #fff;
    background-color: var(--main-blue) !important;
    border-color: var(--main-blue) !important;
}

.job-form {
    padding: 50px;
}

.job-form .form-group {
    justify-content: space-between;
    margin: 20px 0px;
}

.job-form .form-control,
.job-form .custom-file {
    outline: none;
    border: 1px solid rgb(230, 230, 230);
    border-radius: 4px;
    height: 50px;
    margin-top: 10px;
    background-color: #bebebe11;
    transition: all 0.5s ease;
}

html:lang(ar) .custom-file-label {
    direction: ltr;
}

.job-form .form-control:focus {
    box-shadow: none;
    border: 1px solid var(--main-blue);
    background: #fff;
    transition: all 0.5s ease;
    box-shadow: 0px 0px 6px #24487961;
}

.job-form .d-block {
    color: var(--main-blue);
    text-align: justify;
    font-size: 18px;
}

.job-form .line {
    border-bottom: 1px solid #bebebe;
    margin: 60px 0 55px;
}

.job-form .tap-name {
    text-align: justify;
    color: var(--main-blue);
    font-weight: bold;
}

@media (min-width: 992px) {
    .job-form .my-row {
        margin-top: 20px;
    }
}

@media (max-width: 991px) {
    .job-form .tap-name {
        font-size: 25px;
    }
}

.job-form .error {
    color: #b61532;
    margin: 5px;
}

.job-form .bi-exclamation-triangle {
    color: #b61532;
    font-size: 18px;
}

.job-form .error-section {
    margin-top: 10px;
    text-align: justify;
}

//button
.job-form .my-button {
    position: relative;
    color: var(--main-blue);
    font-size: 16px;
    // font-weight: bold;
    text-decoration: none;
    margin: 30px 0 0;
    border: 1px solid var(--main-blue);
    padding: 10px 30px;
    overflow: hidden;
    transition: 0.6s all ease;
    background: transparent;
    border-radius: 5px;
    z-index: 100000;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 55px;
}

.job-form .my-button::before {
    background: var(--main-blue);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all 0.6s ease;
}

.job-form .my-button .spinner-border {
    width: 23px !important;
    height: 23px !important;
    margin: 0px 10px 0px 0px;
    color: var(--main-blue);
}

html:lang(en) .job-form .my-button .spinner-border {
    margin: 0px 10px 0px 0px;
}

html:lang(ar) .job-form .my-button .spinner-border {
    margin: 0px 0px 0px 10px;
}

.job-form .my-button:hover {
    color: #fff;
    // font-weight: 500;

    .spinner-border {
        color: #fff !important;
    }
}

.job-form .my-button::before {
    width: 0%;
    height: 102%;
}

.job-form .my-button:hover::before {
    width: 102%;
}

////
.job-form .bv-no-focus-ring {
    text-align: justify;
    margin-top: 30px;
}

.job-form .custom-control-label::before {
    width: 25px;
    height: 25px;
    margin-left: -15px;
    margin-top: -9px;
}

.job-form .custom-control-label {
    margin-left: 15px;
    cursor: pointer;
}

.job-form .custom-control-label::after {
    top: -6px;
    left: -40px;
    width: 26px;
    height: 26px;
}

.job-form .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: var(--main-blue);
    background-color: var(--main-blue);
    box-shadow: 0px 0px 6px #24487961;
}

//date

.job-form .b-form-btn-label-control.form-control {
    height: 50px;
}

.job-form .b-form-btn-label-control.form-control > .form-control {
    text-align: justify;
    margin-top: 5px;
}

.job-form .bi-calendar,
.job-form .bi-calendar-fill {
    color: var(--main-blue);
}

///select

.job-form .my-select {
    outline: none;
    border: 1px solid rgb(230, 230, 230);
    border-radius: 4px;
    height: 50px;
    margin-top: 2px;
    background-color: rgba(190, 190, 190, 0.0666666667);
    transition: all 0.5s ease;
    width: 100%;
    padding: 0px 10px;
    color: #495057;
}

//card

.job-form .card {
    border-radius: 10px;
    padding: 45px 30px;
    align-items: center;
    transition: all 0.5s;
}

.job-form .card:hover {
    box-shadow: 0 0 15px rgba(128, 128, 128, 0.37);
    transition: all 0.5s;
}

.job-form .card-position {
    color: var(--main-blue);
    font-weight: bold;
    margin-bottom: 1rem;
}

.job-form .card-shift {
    color: var(--main-green);
    font-size: 18px;
    font-weight: bold;
}

.job-form .card-disc {
    color: #777;
}

.job-form .apply-button {
    position: relative;
    color: var(--main-blue);
    font-size: 13px;
    // font-weight: 800;
    text-decoration: none;
    margin: 30px 0 0;
    border: 1px solid var(--main-blue);
    padding: 6px 15px;
    overflow: hidden;
    transition: 0.6s all ease;
    background: #fff;
    border-radius: 10px;
    z-index: 100000;
    // width: 65%;
}

.job-form .apply-button::before {
    background: var(--main-blue);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all 0.6s ease;
}

.job-form .apply-button:hover {
    color: #fff;
    // font-weight: 800;
}

.job-form .apply-button::before {
    width: 0%;
    height: 102%;
}

.job-form .apply-button:hover::before {
    width: 102%;
}

.job-form .card-row {
    row-gap: 20px;
}

.job-form .before-enter {
    opacity: 0;
    transform: translateY(150px);
    transition: all 0.5s;
}

.job-form .enter {
    opacity: 1;
    transform: translateY(0px);
}
</style>